// extracted by mini-css-extract-plugin
module.exports = {"root":"PayoutsCoinsList_root__aXiCT","open":"PayoutsCoinsList_open__iknEP","toggle":"PayoutsCoinsList_toggle__7Bd_h","arrowIcon":"PayoutsCoinsList_arrowIcon__FQ2iV"};